import { fetchUserRecommendations, TeamSearchField } from '@atlaskit/smart-common';

import type { BootstrapState } from '../../../common/constants/bootstrap';
import { type onError } from '../../error-boundary/utils';

export const fetchPeopleAndTeamsResults = (
	query: string,
	bootstrap: BootstrapState,
	onError: onError,
) => {
	const fetchData = async (query: string) => {
		performance.mark('fetchPeopleAndTeamsResultsStart');

		// Map townsquare scope as URS does not support townsquare as a primary product
		const productKey =
			bootstrap.primaryProduct === 'townsquare' ? 'people' : bootstrap.primaryProduct;

		const recommendations = await fetchUserRecommendations({
			query,
			context: {
				contextType: 'full_page_search',
				siteId: bootstrap.cloudId || '',
				productKey: productKey || '',
				principalId: bootstrap.user?.id || '',
				organizationId: bootstrap.orgId || '',
			},
			includeUsers: true,
			includeTeams: true,
			includeGroups: false,
			maxNumberOfResults: 3,
			performSearchQueryOnly: false,
			searchQuery: {
				filter:
					'account_status:"active" AND (NOT email_domain:"connect.atlassian.com") AND (NOT account_type:app)',
				teamSearchFields: [TeamSearchField.NAME],
			},
		}).catch((error) => {
			onError(error);
			return [];
		});

		performance.mark('fetchPeopleAndTeamsResultsEnd');

		const { duration } = performance.measure(
			'fetchPeopleAndTeamsResultsDuration',
			'fetchPeopleAndTeamsResultsStart',
			'fetchPeopleAndTeamsResultsEnd',
		);

		return {
			results: recommendations,
			duration,
		};
	};

	return fetchData(query);
};
